<template>
  <div>
    <v-subheader class="title">Actions</v-subheader>
    <v-card tile flat class="transparent ma-0">
      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout>
            <v-flex class="mt-2">
              <span class="font-weight-light">Current Status:</span> {{ enquiry.status.name }}
            </v-flex>
            <v-flex>
              <v-btn :color="colour" depressed class="px-3 mx-0" small @click="updateStatus" v-if="statusCanUpdate">
                Update
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <enquiry-pending-dialog
      v-if="enquiry.status.name === 'PENDING'"
      :show.sync="showPending"
      :enquiry="enquiry"
    ></enquiry-pending-dialog>
    <enquiry-accepted-dialog
      v-if="enquiry.status.name === 'ENQUIRY ACCEPTED'"
      :show.sync="showAccepted"
      :enquiry="enquiry"
    ></enquiry-accepted-dialog>
    <enquiry-in-underwriting-dialog
      v-if="enquiry.status.name === 'IN UNDERWRITING'"
      :show.sync="showInUnderwriting"
      :enquiry="enquiry"
    ></enquiry-in-underwriting-dialog>
    <enquiry-offer-made-dialog
      v-if="enquiry.status.name === 'FUNDER OFFER MADE'"
      :show.sync="showOfferMade"
      :enquiry="enquiry"
    ></enquiry-offer-made-dialog>
    <enquiry-offer-accepted-dialog
      v-if="enquiry.status.name === 'SME OFFER ACCEPTED'"
      :show.sync="showOfferAccepted"
      :enquiry="enquiry"
    ></enquiry-offer-accepted-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import EnquiryPendingDialog from './EnquiryPendingDialog';
import EnquiryAcceptedDialog from './EnquiryAcceptedDialog';
import EnquiryInUnderwritingDialog from './EnquiryInUnderwritingDialog';
import EnquiryOfferMadeDialog from './EnquiryOfferMadeDialog';
import EnquiryOfferAcceptedDialog from './EnquiryOfferAcceptedDialog';

export default {
  components: {
    EnquiryPendingDialog,
    EnquiryAcceptedDialog,
    EnquiryInUnderwritingDialog,
    EnquiryOfferMadeDialog,
    EnquiryOfferAcceptedDialog
  },
  name: 'enquiry-actions',
  props: ['customer'],
  data: () => ({
    enquiry: {
      status: {}
    },
    showPending: false,
    showAccepted: false,
    showInUnderwriting: false,
    showOfferMade: false,
    showOfferAccepted: false
  }),
  computed: {
    ...mapGetters(['SelectedEnquiry', 'StatusColours']),
    colour() {
      let status = _.find(this.StatusColours, ['status', this.enquiry.status.name]);
      if (_.isUndefined(status)) {
        status = { colour: 'light-grey' };
      }
      return status.colour;
    },
    statusCanUpdate() {
      return (
        this.enquiry.status.name === 'PENDING' ||
        this.enquiry.status.name === 'ENQUIRY ACCEPTED' ||
        this.enquiry.status.name === 'FUNDER OFFER MADE' ||
        this.enquiry.status.name === 'SME OFFER ACCEPTED' ||
        this.enquiry.status.name === 'IN UNDERWRITING'
      );
    }
  },
  methods: {
    ...mapActions(['storeCustomerEnquiry']),
    updateStatus() {
      switch (this.enquiry.status.name) {
        case 'PENDING':
          this.showPending = true;
          break;
        case 'ENQUIRY ACCEPTED':
          this.showAccepted = true;
          break;
        case 'IN UNDERWRITING':
          this.showInUnderwriting = true;
          break;
        case 'FUNDER OFFER MADE':
          this.showOfferMade = true;
          break;
        case 'SME OFFER ACCEPTED':
          this.showOfferAccepted = true;
          break;
      }
    }
  },
  mounted() {
    this.enquiry = this.SelectedEnquiry;
  }
};
</script>

<style lang="scss">
::v-deep .input-group ::v-deep label {
  font-size: 13px;
}
</style>
